// SignalRContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { hubConnection } from "signalr-no-jquery";

const HiDeviceContext = createContext(null);

export function HiDeviceProvider({ children }) {
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    const conn = hubConnection("http://localhost:6060", { cors: true });
    const connHubProxy = conn.createHubProxy("hiConnectionHub");
    conn.start()
      .done(() => console.log("SignalR Connected"))
      .fail(err => console.error("Connection failed:", err));

    setConnection({connection:conn, hubProxy:connHubProxy});

    return () => {
      conn.stop();
    };
  }, []);

  return (
    <HiDeviceContext.Provider value={connection}>
      {children}
    </HiDeviceContext.Provider>
  );
}

export function useHiDevice() {
  return useContext(HiDeviceContext);
}
